<template>
  <v-card v-if="!loading">
    <v-card-title :style="style" class="px-2">
      <v-btn icon @click="$emit('closeEndorsementsDialog')">
        <v-icon color="white">mdi-keyboard-backspace</v-icon>
      </v-btn>
      Endorsements ({{ formattedTotalPremium }})
    </v-card-title>
    <v-card-text class="pa-0">
      <v-card outlined class="py-1">
        <v-card-title class="subtitle-1 pb-0 pl-3">
          Earthquake
        </v-card-title>
        <v-card-text>
          <v-row wrap>
            <template v-if="!earthquake.coverage">
              <v-col cols="12" class="py-1 my-1">
                <DisplayField label="Coverage" :value="earthquake.coverage" type="bool" />
              </v-col>
            </template>
            <template v-else>
              <v-col cols="6" class="py-1">
                <DisplayField label="Deductibles" :value="earthquake.deductibles" />
              </v-col>
              <v-col cols="6" class="py-1">
                <DisplayField label="Premium" :value="earthquake.premium" type="currency" />
              </v-col>
              <v-col cols="6" class="py-1">
                <DisplayField label="Include Masonry Veneer" :value="earthquake.includeMasonryVeneer" type="bool" />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined class="py-1 my-1">
        <v-card-title class="subtitle-1 pb-0 pl-3">
          Watercrafts
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <DisplayField label="Premium" :value="watercraftsPremium" type="currency" />
            </v-col>
          </v-row>
          <v-row v-for="(watercraft, w) in watercrafts" :key="w" wrap>
            <v-col cols="3" class="py-1">
              <DisplayField label="Type" :value="watercraft.boatPropulsionType" />
            </v-col>
            <v-col cols="3" class="py-1">
              <DisplayField label="HP" :value="watercraft.horsePower" type="number" />
            </v-col>
            <v-col cols="3" class="py-1">
              <DisplayField label="Speed" :value="watercraft.speed" type="number" />
            </v-col>
            <v-col cols="3" class="py-1">
              <DisplayField label="Length" :value="watercraft.length" type="number" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <SmallTableCard
        outlined
        title="Misc Endorsements"
        :items="miscellaneous"
        three-column
        :headers="['Limit', 'Premium']"
        :fields="[ { name: 'name', type: ''}, { name: 'limits', type: ''}, { name: 'premium', type: 'currency'} ]" />
    </v-card-text>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading Scheduled Property...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style>
.section-header {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #767676;
  }
</style>

<script>
import { mapActions } from 'vuex';
import SmallTableCard from '@/components/Shared/SmallTableCard.vue';
import DisplayField from '@/components/Shared/DisplayField.vue';
import apiService from '@/services/shared/agentPortalApiService.js';
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import coverageTranslator from '@/services/clientViewer/coverageTranslator.js';

export default {
  name: 'HomeEndorsements',
  components: { SmallTableCard, DisplayField },
  props: {
    clientId: {
      type: String,
      required: true
    },
    policyOrderNumber: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      endorsements: null,
      loading: true,
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      }
    };
  },
  computed: {
    formattedTotalPremium: function () {
      if ((this.endorsements || null) === null) {
        return 0;
      }
      return displayFormatterService.formatCurrency(this.endorsements.totalPremium);
    },
    totalPremiumTitle: function () {
      return 'Total Premium ' + this.formattedTotalPremium;
    },
    earthquake: function () {
      if ((this.endorsements || null) === null) {
        return {};
      }
      return this.endorsements.earthquake;
    },
    watercrafts: function () {
      if ((this.endorsements || null) === null) {
        return [];
      }
      return this.endorsements.watercrafts;
    },
    watercraftsPremium: function () {
      var totalPremium = 0;
      this.watercrafts.map(x => {
        totalPremium += x.premium;
      });
      return totalPremium;
    },
    miscellaneous: function () {
      if ((this.endorsements || null) === null) {
        return [];
      }
      return this.endorsements.miscellaneous;
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getHomeEndorsements(this.clientId, this.policyOrderNumber);
    if (rs.code === 0) {
      if (rs.data.length === 0) this.endorsements = {};

      this.endorsements = coverageTranslator.translateHomeEndorsements(rs.data[0]);
    } else {
      this.error = true;
      this.setError(rs.message);
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
